export default __webpack_public_path__ + "static/media/caja-arequipa.c42c41cd.svg";